var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"interest-level-select-wrapper",attrs:{"tabindex":"0"}},'div',_vm.$attrs,false),_vm.$listeners),[(_vm.color !== null)?_c('span',{staticClass:"dot",class:{ [_vm.color]: _vm.color }}):_vm._e(),_c('span',{class:{ selected: _vm.selected }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }